module.exports = "/static/geo/us-states.json";